'use strict';
const angular = require('angular');

export class payFeesOnlineWidgetComponent {

  constructor($uibModal) {
    'ngInject';

    this.$uibModal = $uibModal;
  }

  openPayPalModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'paymentComponent',
      resolve: {}
    });

    modalInstance.result.then(
      function () {},
      function () {}
    );
  }

  $onInit() {
  }
}

export default angular.module('conduuApp.payFeesOnlineWidget', [])
  .component('payFeesOnlineWidget', {
    template: `<a ng-click="$ctrl.openPayPalModal()" class="btn btn-more btn-feedback-form"><i ng-if="$ctrl.icon" 
                class="fa {{$ctrl.icon}}"></i> {{$ctrl.title || 'Pay Fees Online'}}</a>`,
    bindings: {
      icon: '@',
      title: '@'
    },
    controller: payFeesOnlineWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/pay-fees-online-widget/pay-fees-online-widget.component.js